export default {
  pageTitle: '活动管理',
  pageDesc: '管理当前工作区下的会议/活动（个人空间为本人活动，公司空间为该公司活动）。',
  noAccessAlert: '暂无活动管理权限，请联系管理员授权。',
  searchPlaceholder: '搜索活动名称 / 地点 / 简介',
  addEvent: '举办新活动',
  editEvent: '编辑活动',
  emptyTable: '暂无活动',
  eventName: '活动名称',
  requiresRegistration: '需要报名',
  registrationApproval: '报名审核',
  approvalRequired: '需审核',
  approvalAuto: '免审核',
  eventCity: '活动省市',
  eventAddress: '详细地点',
  eventIntro: '活动简介',
  creator: '创建人',
  createdAt: '创建时间',
  namePlaceholder: '请输入活动名称',
  registrationNeedsApproval: '报名需审核',
  cityPlaceholder: '如：广东省广州市',
  citySelectPlaceholder: '请选择省/市',
  cityAbroadPlaceholder: '国外地址可直接填写',
  cityRequired: '请选择举办城区，或填写国外地址',
  addressPlaceholder: '请输入会议详细地址',
  introPlaceholder: '请输入活动简介',
  nameRequired: '请输入活动名称',
  switchCompanyFirst: '请先切换到公司空间',
  createSuccess: '活动创建成功',
  createFailed: '活动创建失败，请稍后重试',
  createModal: {
    title: '填写活动基础信息',
    startTime: '活动开始时间',
    endTime: '活动结束时间',
    timeRange: '活动时间',
    timeRangeRequired: '请选择活动时间',
    city: '举办城区',
    startRequired: '请选择活动开始时间',
    endRequired: '请选择活动结束时间',
    addressRequired: '请填写活动地点',
    introRequired: '请填写活动简介',
    endAfterStart: '结束时间须晚于开始时间',
    submit: '保存并创建活动'
  },
  createSuccessModal: {
    title: '活动创建成功！',
    desc: '活动基础信息已保存。\n你可以现在前往完善活动页面装修与配置，\n也可以稍后在活动管理中继续编辑。',
    goConfig: '🎨 现在去完成活动配置',
    later: '暂不填写，稍后完成'
  },
  updateSuccess: '活动更新成功',
  loadFailed: '活动详情加载失败，请稍后重试',
  deleteConfirmTitle: '删除确认',
  deleteConfirmMessage: '确定要删除活动「{name}」吗？',
  deleteConfirmOk: '确定删除',
  deleteSuccess: '删除成功',
  eventCreateGate: {
    needEventFirst: '请先完成「活动信息」保存以创建活动，再继续本页操作。'
  },
  wizardNav: {
    primaryAria: '活动向导一级导航',
    primaryEvent: '活动',
    primaryDecoration: '创建装修',
    primaryRegistration: '报名',
    backToList: '返回活动列表',
    close: '关闭',
    /** 二级侧栏标题（设计稿「活动设置」） */
    settingsLabel: '活动设置',
    groupBasic: '基础设置',
    groupRegistration: '报名相关',
    groupPageDecoration: '页面装修',
    groupMore: '更多',
    eventInfo: '活动基础信息',
    location: '地点设置',
    registration: '报名设置',
    registrationForm: '问卷',
    share: '分享设置',
    shareTemplate: '活动分享模板',
    micrositeCreate: '页面装修',
    activityConfig: '活动配置',
    schedule: '会议日程',
    regConfig: '报名配置',
    seatRec: '座位编辑',
    transferCfg: '接送配置',
    hotelCfg: '酒店配置',
    diningCfg: '用餐配置',
    pickup: '接送管理',
    dining: '用餐管理',
    seating: '座位管理',
    checkin: '签到管理',
    lotteryScreen: '巨屏抽奖',
    taskManage: '任务管理',
    smsNotifications: '短信通知',
    toggleDecoration: '展开或收起活动配置子菜单'
  },
  eventInfo: {
    pageTitle: '活动基础信息',
    lastSaved: '最后保存时间',
    saveBtn: '保存活动信息',
    sectionBasic: '📋 基本信息',
    helpTitle: '说明',
    helpDesc: '在此页填写活动基本信息、地点与报名设置；活动省市请通过省/市级联选择。'
  },
  eventLocation: {
    pageTitle: '地点设置',
    helpTitle: '说明',
    helpDesc: '设置活动举办的城市与详细地址，将展示在报名页与活动详情中。'
  },
  eventRegistration: {
    pageTitle: '报名设置',
    helpTitle: '说明',
    helpDesc: '开启报名后，用户可提交报名信息；若需审核，请开启「报名需审核」。'
  },
  /** 活动向导 · 分享模板（海报预览/下载，不落库） */
  shareTpl: {
    pageTitle: '活动分享模板',
    generatePoster: '生成分享海报',
    sectionTemplate: '海报模板选择',
    sectionContent: '分享内容设置',
    tplBlue: '经典蓝',
    tplBluePurple: '经典蓝',
    tplDarkTech: '深色科技',
    tplFreshGreen: '清新绿意',
    tplWarmOrange: '暖橙商务',
    shareTitle: '主标题',
    shareTitlePlaceholder: '请输入主标题',
    shareSubtitle: '副标题',
    shareSubtitlePlaceholder: '请输入副标题',
    shareDesc: '副标题',
    shareDescPlaceholder: '请输入副标题',
    hostLabel: '主办方',
    hostPlaceholder: '请输入主办方名称',
    posterCover: '海报头图',
    posterCoverHint: '建议宽高比约 16:9，JPG / PNG，不超过 3M',
    posterCoverUpload: '上传头图',
    posterCoverUploading: '上传中…',
    posterCoverUploadSuccess: '海报头图上传成功',
    posterCoverUploadFailed: '海报头图上传失败，请稍后重试',
    posterCoverClear: '移除头图',
    posterCoverPlaceholder: '请上传头图',
    posterCta: '长按扫码 报名参与活动',
    posterAttr: '本页面由半度云智能会务系统提供',
    qrHidden: '已关闭二维码',
    displayItems: '显示内容',
    showTime: '活动时间',
    showLocation: '活动地点',
    showHost: '主办方',
    showQr: '活动首页二维码',
    shareLink: '分享链接',
    activityLink: '活动链接',
    copy: '复制',
    copySuccess: '链接已复制',
    copyFailed: '复制失败',
    homeLinkHint: '链接指向本活动微站首页，与「页面装修」预览一致',
    noHomeLinkHint: '尚未设置微站首页，请先在「页面装修」中创建并设为首页',
    noHomeLinkPlaceholder: '暂无微站首页链接',
    qrNeedHome: '请先设置微站首页',
    preview: '预览效果',
    downloadPng: '下载海报（PNG）',
    downloadSuccess: '海报已下载',
    downloadFailed: '下载失败，请稍后重试',
    brand: '半度云 · 智能会务系统',
    titleEmptyPlaceholder: '（未填写标题）',
    metaUnset: '暂未设置',
    sectionWechatShare: '微信分享',
    wechatShareTip: '配置好友会话中转发卡片的标题、副标题与封面。与上方海报标题/描述一并保存到活动分享配置。',
    wechatTitle: '分享标题',
    wechatTitlePlaceholder: '可留空，留空则回落为活动名称',
    wechatTitleFallback: '（将使用活动名称）',
    wechatSubtitle: '副标题',
    wechatSubtitlePlaceholder: '选填，显示在标题下方',
    wechatSubtitleFallback: '半度云 · 活动',
    wechatImage: '分享图',
    wechatImageHint: '建议尺寸 500×500px，支持 JPG / PNG，大小不超过 3M',
    wechatImageUpload: '上传分享封面',
    wechatImageUploading: '上传中…',
    wechatImageUploadSuccess: '分享图上传成功',
    wechatImageUploadFailed: '分享图上传失败，请稍后重试',
    wechatImageClear: '移除图片',
    wechatImageTypeError: '仅支持 JPG / PNG 图片',
    wechatImageSizeError: '图片大小不能超过 3M',
    saveShare: '保存分享设置',
    saveShareSuccess: '分享设置已保存',
    saveShareFailed: '分享设置保存失败，请稍后重试',
    wechatPreview: '微信卡片预览',
    wechatThumbPlaceholder: '封面'
  },
  /** 活动向导 · 报名配置（对齐设计稿 vRegSetup） */
  regSetup: {
    tabsLabel: '报名管理',
    tabRecords: '报名记录',
    tabOrders: '订单',
    tabStatistics: '统计',
    questionnaireSettingsHint: '允许修改和关闭报名入口请前往问卷设置，所有关联活动统一生效。',
    sectionBasic: '基础设置',
    sectionAdvanced: '高级设置',
    selectForm: '报名表',
    selectFormHint: '选择本活动使用的问卷表格',
    selectFormPlaceholder: '请选择报名表',
    formStatusDraft: '草稿',
    formRequired: '请选择报名表',
    formLockedTitle: '提示',
    formLockedConfirm: '报名设置已保存，问卷不可更改。',
    saveBindTitle: '确认',
    saveBindConfirm: '选择问卷后不可更改，确认？',
    proxyLockedTip: '🔒 勾选「允许团体报名」后可编辑对接人名单',
    proxyNeedBindTip: '请先点击「保存设置」完成问卷绑定后，再录入对接人名单',
    saveSettingsBtn: '保存设置',
    saveBtn: '保存报名设置',
    saveSuccess: '报名设置已保存',
    saveFailed: '保存失败，请稍后重试',
    loadFormsFailed: '加载问卷列表失败',
    loadFormFailed: '加载问卷设置失败',
    noForms: '暂无问卷，请先在「问卷管理」中创建',
    goFormManage: '前往问卷管理',
    formManageTip: '若无可选报名表，请先在「问卷管理」中新增报名表。',
    goConfigure: '前往配置 →',
    statsPageTitle: '报名统计',
    statsExport: '导出统计报告',
    statsExportSoon: '导出功能即将开放',
    statsNeedForm: '请先在报名配置中绑定问卷后查看统计',
    statsLoadFailed: '加载统计失败，请稍后重试',
    statsTotal: '总报名人数',
    statsSelf: '个人报名',
    statsProxy: '团队报名',
    statsAvgDaily: '平均每日报名',
    statsProxyDist: '社团报名分布',
    statsProxyDistEmpty: '暂无对接人报名数据',
    statsTrend7d: '报名趋势（近7天）',
    statsTrendUnit: '单位：人',
    statsTrendTotal: '7天累计',
    statsTrendAvg: '日均',
    statsTrendPeak: '峰值',
    statsPeopleUnit: '人',
    statsFeeIncome: '费用收入汇总',
    statsFeeRegistration: '报名费',
    statsFeeHotel: '酒店住宿',
    statsFeeMeal: '用餐费',
    statsFeeShuttle: '接送费',
    statsFeePending: '（暂未开放）',
    statsReview: '审核状态',
    statsReviewApproved: '已通过',
    statsReviewPending: '待审核',
    statsReviewRejected: '已拒绝',
    statsDeadlinePrefix: '报名截止时间：{time}',
    statsDeadlineRemainMid: '距截止还有',
    statsDeadlineRemainSuffix: '天',
    statsDeadlineTodayMid: '今天截止',
    statsDeadlinePassedMid: '已截止',
    statsDeadlinePassedSuffix: '天',
    mailTemplate: {
      sectionTitle: '对接邀请邮件模板',
      hint: '每个活动仅一份模板。主题或正文留空时，该侧发信将回退系统默认。可点击下方按钮插入变量。',
      subject: '邮件主题',
      subjectPlaceholder: '{{activityName}} 问卷录入邀请',
      body: '邮件正文',
      bodyPlaceholder: '请输入邮件正文，例如：您好，请通过邀请链接完成问卷录入…',
      insertPlaceholder: '插入变量',
      placeholderHelp: '变量说明',
      phInsertAs: '插入为 {token}',
      imageNotSupported: '邮件正文暂不支持插入图片',
      saveBtn: '保存邮件模板',
      saveSuccess: '邮件模板已保存',
      saveFailed: '保存邮件模板失败',
      loadFailed: '加载邮件模板失败',
      updatedAt: '最近更新：{time}',
      ph: {
        activityName: '活动名',
        formTitle: '报名表单标题',
        recipientName: '对接人姓名',
        magicLinkUrl: '邀请链接',
        linkExpireDays: '链接有效天数',
        appName: '应用名'
      }
    }
  },
  schedule: {
    pageTitle: '会议日程',
    helpTitle: '说明',
    helpDesc: '管理活动下的单场会议/议程，按日期分组展示。',
    add: '添加',
    addAgenda: '添加会议议程',
    edit: '编辑',
    delete: '删除',
    colName: '会议名称',
    colAgendaName: '议程名称',
    colTime: '开始-结束时间',
    colTimeRange: '会议时间段',
    colLocation: '地点',
    colVenue: '座位场地',
    colSortOrder: '排序',
    colIntro: '会议简介',
    colActions: '操作',
    formTitleAdd: '添加会议议程',
    formTitleEdit: '编辑会议议程',
    formSectionBasic: '基础信息',
    formStart: '会议开始',
    formEnd: '会议结束',
    formRegion: '会议区域',
    formAddress: '详细地址',
    formPlace: '地点',
    formSortOrder: '排序',
    regionPlaceholder: '请选择省/市/区',
    regionAbroadPlaceholder: '国外地址可直接填写',
    addressPlaceholder: '请输入详细地址',
    placePlaceholder: '请输入地点',
    sortOrderHint: '同一天内数值越小，排列越靠前；相同数值按开始时间排列。',
    sortOrderInvalid: '排序须为不小于 0 的整数',
    dragSortHint: '拖动调整同一天内的排列顺序',
    sortSaved: '排序已保存',
    sortSaveFailed: '排序保存失败，已恢复原顺序',
    introTip: '如需[装修]会议详情页面，简介的内容会在装修中展示，请选填',
    submitAdd: '确认添加议程',
    submitEdit: '保存议程',
    backToList: '返回列表',
    formHelpDesc: '填写单场会议的名称、时间、地点与简介；带 * 为必填项。',
    emptyList: '暂无会议议程',
    emptyDay: '暂无会议议程',
    unknownDate: '未设置日期',
    activityTimeRangeHint: '根据【活动始末时间】可选时间范围：{range}',
    needActivityTimeFirst: '请先在「活动基础信息」中设置活动开始与结束时间',
    timeOutOfActivityRange: '须在活动起止时间范围内选择',
    nameRequired: '请输入议程名称',
    startRequired: '请选择会议开始时间',
    endRequired: '请选择会议结束时间',
    endAfterStart: '结束时间须晚于开始时间',
    regionRequired: '请选择会议区域，或填写国外地址',
    addressRequired: '请输入详细地址',
    namePlaceholder: '请输入议程名称',
    introPlaceholder: '请输入会议简介',
    createSuccess: '议程添加成功',
    updateSuccess: '议程更新成功',
    saveFailed: '保存失败，请稍后重试',
    deleteConfirmTitle: '删除确认',
    deleteConfirmMessage: '确定要删除这 {count} 条会议议程吗？',
    deleteSuccess: '删除成功',
    deleteFailed: '删除失败',
    loadFailed: '加载会议日程失败'
  },
  checkin: {
    tabSettings: '基本设置',
    tabUsers: '签到名单',
    tabFields: '人员展示字段',
    tabSuccess: '成功页设置',
    tabPage: '页面装修',
    create: '新增签到',
    createSuccess: '签到已创建',
    empty: '暂无签到，请先新增',
    name: '签到名称',
    namePh: '请输入签到名称',
    nameRequired: '请输入签到名称',
    colCheckinName: '签到名称',
    colMeeting: '绑定场次',
    colSigned: '已签 / 名单',
    colEntry: '签到入口',
    colScanEntry: '扫码入口',
    meetingNone: '不绑定场次',
    openEdit: '设置',
    copyH5: '复制入口',
    copyEntry: '点击复制',
    qrBtn: '二维码',
    backToList: '返回签到列表',
    deleteConfirmTitle: '删除签到',
    deleteConfirmMessage: '确定删除「{name}」？名单与签到记录将一并删除。',
    deleteSuccess: '签到已删除',
    type: '签到方式',
    typeSearch: '搜索签到',
    typeLocate: '定位签到',
    typeScan: '扫码签到',
    status: '启用状态',
    statusOn: '启用',
    statusOff: '停用',
    needPrint: '需要打印',
    needPrintYes: '是',
    needPrintNo: '否',
    timeWindow: '签到时间窗',
    startTime: '开始时间',
    endTime: '结束时间',
    startAfterActivity: '签到开始时间不能晚于活动开始时间（{time}）',
    startAfterActivityHint: '开始时间不得晚于活动开始时间：{time}',
    address: '签到地址',
    addressPh: '可覆盖活动地址，留空则展示活动地点',
    latitude: '纬度',
    longitude: '经度',
    radius: '半径（米）',
    radiusHint: '定位签到必填',
    customFields: '自定义列',
    fieldKey: '字段标识',
    fieldLabel: '中文名称',
    fieldKeyPh: '例如 company、seat',
    fieldLabelPh: '显示给用户的名称',
    addField: '添加字段',
    fieldsSection: '签到人扩展信息',
    fieldsSectionHint: '配置名单模板、后台列表和签到成功页需要展示的附加资料。',
    fieldsTemplateTip: '保存后请重新下载该签到的名单模板，模板会自动使用这里配置的中文名称。',
    fieldIncomplete: '自定义字段需同时填写字段标识和中文名称',
    fieldKeyInvalid: '字段标识须为英文小写开头，仅含字母、数字和下划线',
    fieldKeyDuplicate: '字段标识不能重复',
    successButtons: '成功页按钮',
    successSection: '签到成功信息按钮',
    successHint: '「跳转链接」填写完整网址；「弹框显示」上传图片。每行最多两个按钮，奇数个时最后一个会自动居中加宽。',
    successImageHint: '二维码建议使用 PNG 或 JPG，四周保留留白；按钮名称建议控制在 8 个字以内。',
    btnName: '按钮名称',
    btnNamePh: '例如：查看活动议程',
    btnNameRequired: '请填写按钮名称',
    btnLink: '跳转链接',
    btnImage: '展示图片',
    btnPopup: '弹框显示',
    btnUrl: 'https://…',
    btnNeedUrl: '第 {n} 个按钮请填写完整跳转链接',
    btnNeedImage: '第 {n} 个弹框按钮请上传图片',
    btnUpload: '上传图片',
    btnReupload: '更换图片',
    btnUploadFailed: '图片上传失败',
    addButton: '添加按钮',
    entryUrls: '公开入口',
    urlH5: '参会者 H5',
    urlScanDesk: '扫码工作台',
    urlPrintDesk: '打印端',
    openQr: '打开二维码',
    entryQrTip: '扫描二维码或复制下方链接打开对应页面',
    save: '保存签到配置',
    saveSuccess: '签到配置已保存',
    copySuccess: '链接已复制',
    copyFailed: '复制失败，请手动复制',
    filterKeyword: '搜索姓名 / 手机号',
    filterStatus: '签到状态',
    statusUnsigned: '未签到',
    statusSigned: '已签到',
    import: '导入',
    export: '导出',
    exportTemplate: '下载模板',
    importTip: 'Excel 须含「姓名」「手机号码」列。自定义列按签到设置填写。同一签到内手机号重复则更新。单次最多 5000 行。',
    importDrop: '拖拽 Excel 到此处，或点击上传',
    importEmpty: '没有可导入的数据行',
    importReady: '已解析 {n} 行，确认后写入',
    importDone: '导入完成：新增 {created}，更新 {updated}，失败 {failed}',
    colName: '姓名',
    colMobile: '手机号',
    phName: '请输入姓名',
    phMobile: '请输入手机号码',
    colStatus: '签到状态',
    colTime: '签到时间',
    colActions: '操作',
    addUser: '新增人员',
    editUser: '编辑人员',
    userNameRequired: '请输入姓名',
    userMobileRequired: '请输入手机号',
    userAddSuccess: '人员已添加',
    userEditSuccess: '人员已保存',
    bgColor: '背景色',
    bgImage: '背景图',
    buttonText: '按钮文案',
    buttonColor: '按钮颜色',
    clearBg: '清除背景图',
    designer: {
      selectNodeHint: '点击画布中的组件进行编辑，或切换「页面 / 搜索区 / 底部 Logo」配置固定组件',
      tabBusiness: '搜索区',
      dividerGradient: '渐变范围',
      previewNeedSave: '请先保存装修后再浏览',
      paletteTitle: '内容组件',
      paletteHint: '添加活动图片，可直接拖到画布中的签到区域上方或下方，添加后仍可拖动排序。',
      compImage: '图片',
      businessLocked: '搜索框、人员结果或定位表单属于业务组件，不可删除，只允许调整样式。',
      devicePhone: '手机',
      deviceWide: '宽屏手机',
      reset: '恢复默认',
      resetConfirm: '恢复默认会清空当前装修内容，是否继续？',
      save: '保存装修',
      preview: '浏览页面',
      propsTitle: '属性设置',
      propsHint: '页面设置始终生效；点击画布组件可编辑组件属性。',
      sectionPage: '页面',
      contentWidth: '内容宽度',
      paddingTop: '顶部间距',
      paddingSide: '左右边距',
      imageLimit: '支持 PNG、JPG、WEBP，最大 10MB',
      imageType: '图片仅支持 PNG、JPG 或 WEBP',
      imageTooLarge: '图片大小不能超过 10MB',
      bgSize: '背景填充',
      bgCover: '覆盖填满',
      bgContain: '完整显示',
      bgAuto: '原始尺寸',
      bgPosition: '背景定位',
      posCenterTop: '顶部居中',
      posLeftTop: '顶部居左',
      posRightTop: '顶部居右',
      posCenter: '页面居中',
      bgRepeat: '重复方式',
      repeatNo: '不重复',
      repeatYes: '平铺重复',
      sectionImage: '选中组件 · 图片',
      position: '显示位置',
      posBefore: '签到组件上方',
      posAfter: '签到组件下方',
      align: '对齐',
      alignLeft: '左对齐',
      alignCenter: '居中',
      alignRight: '右对齐',
      widthPct: '宽度 %',
      radius: '圆角',
      marginTop: '上方间距（px）',
      marginBottom: '下方间距（px）',
      clickToEdit: '点击画布中的内容组件进行编辑。固定业务组件样式请在下方设置。',
      sectionPanel: '业务区域',
      padding: '内边距',
      shadow: '显示阴影',
      sectionInput: '输入框',
      inputHint: '颜色使用系统默认值，仅开放尺寸设置。',
      height: '高度',
      fontSize: '字号',
      sectionButton: '签到按钮',
      textColor: '文字色',
      uploadHint: '点击组件后在右侧上传图片',
      dropBefore: '拖拽到这里，显示在签到组件上方',
      dropAfter: '拖拽到这里，显示在签到组件下方'
    }
  },
  seating: {
    pageTitle: '座位分配记录',
    tabQueryPages: '页面编辑',
    tabRecords: '座位表',
    add: '新增',
    import: '导入',
    export: '导出',
    exportTemplate: '导出模板',
    adjust: '调整座位',
    empty: '暂无座位分配记录',
    filterMeeting: '全部会议场次',
    filterKeyword: '搜索姓名 / 座位号',
    colId: 'ID',
    colSeatNo: '座位号',
    colName: '姓名',
    colPhone: '手机号',
    colSeatType: '座位类型',
    colSession: '所属场次',
    colRow: '行号',
    colCol: '列号',
    colRemark: '备注',
    typeNormal: '普通座位',
    typeVip: '贵宾座位',
    formTitleAdd: '新增座位',
    formTitleEdit: '调整座位',
    phName: '请输入姓名',
    phPhone: '请输入手机号',
    phSeatNo: '请输入座位号',
    phSession: '请选择场次',
    phRemark: '选填',
    seatNoRequired: '请填写座位号',
    meetingRequired: '请选择所属场次',
    createSuccess: '座位已新增',
    updateSuccess: '座位已更新',
    deleteSuccess: '座位已删除',
    deleteConfirm: '确定删除座位 {seatNo} 吗？',
    importTip: 'Excel 列：ID、座位号、姓名、手机号、座位类型、所属场次（会议日程 ID，选填）、行号、列号、备注。ID 存在则更新，不存在则新增。所属场次可留空。请先下载模板。单次最多 1000 行。',
    importDrop: '拖拽 Excel 到此处，或点击上传（.xlsx / .xls）',
    importTypeError: '请上传 .xlsx 或 .xls 文件',
    importEmpty: '没有可导入的数据行',
    importParseFailed: '解析 Excel 失败',
    importReady: '已解析 {n} 行，确认后写入',
    importDone: '导入完成：新增 {created}，更新 {updated}，失败 {failed}',
    importRowFail: '第 {row} 行：{message}',
    enterEditor: '进入座位编辑器',
    queryList: {
      pageTitle: '座位查询页',
      add: '新增查询页',
      empty: '暂无座位查询页',
      filterName: '搜索名称',
      meetingNone: '无场次',
      colName: '名称',
      colActivity: '所属活动',
      colSession: '会议日程',
      colPageUrl: '页面分享',
      pageUrlBtn: '浏览',
      editBtn: '页面装修',
      shareTitle: '页面地址',
      shareTip: '扫描二维码或复制下方链接打开查询页',
      copyLink: '复制',
      copySuccess: '链接已复制',
      copyFailed: '复制失败，请手动复制'
    },
    queryEditor: {
      pageSelectPlaceholder: '选择历史页面',
      pageNew: '新建查询页',
      pageNamePlaceholder: '查询座位 + 随机编号',
      dragToDelete: '拖动到此处删除',
      deviceNormal: '普通手机',
      deviceWide: '宽屏手机',
      browse: '浏览',
      paletteTitle: '组件库',
      groupBasic: '基础组件',
      groupLayout: '布局组件',
      compText: '文本',
      compImage: '图片',
      compSeatMap: '座位图',
      compQueryBg: '查座位背景图',
      compSpacer: '空白',
      compDivider: '分割线',
      compFloatButton: '悬浮按钮',
      canvasTitle: '页面效果',
      dragSort: '拖动排序',
      propsTitle: '组件属性',
      selectNodeHint: '点击画布中的组件进行编辑，或切换「页面 / 查询器 / 提示区 / 底部 Logo」配置固定组件',
      showComponent: '显示',
      tabProps: '属性',
      tabPage: '页面',
      tabQuery: '查询器',
      tabHint: '提示区',
      tabLogo: '底部 Logo',
      fieldContent: '文本内容',
      fieldFontSize: '字号',
      fieldFontWeight: '粗细',
      fieldColor: '颜色',
      fieldAlign: '对齐',
      fieldWidth: '宽度（%）',
      fieldHeight: '高度（px）',
      fieldRadius: '圆角',
      fieldBgColor: '背景色',
      alignLeft: '左',
      alignCenter: '中',
      alignRight: '右',
      weightRegular: '常规',
      weightMedium: '中等',
      weightSemibold: '半粗',
      weightBold: '粗体',
      seatMapHint: '建议上传清晰的座位布局图，支持 JPG、PNG、GIF 格式。',
      queryBgHint: '独立图层，不包裹其他组件。点左侧蓝色手柄或组件库中的「查座位背景图」即可选中；查询框周围的空白处也可点到背景图。排在后面的组件会盖在背景图之上。',
      queryBgSingle: '查座位背景图只能添加一个',
      queryBgSelectHint: '已添加，点击选中',
      queryBgHandle: '选中背景图，拖动手柄调整叠放',
      fieldPosition: '位置',
      fieldOffsetY: '距顶（px）',
      fieldPaddingTop: '上内边距（px）',
      fieldPaddingBottom: '下内边距（px）',
      queryType: '查询类型',
      queryTypeName: '仅姓名',
      queryTypePhone: '仅手机号',
      queryTypeBoth: '姓名 + 手机号',
      matchMode: '匹配逻辑',
      matchExact: '精确匹配',
      matchFuzzy: '模糊匹配',
      inputWidth: '输入框长度（%）',
      inputRadius: '输入框圆角',
      queryAlign: '输入框位置',
      buttonPlacement: '按钮位置',
      buttonRow: '与输入框同一行',
      buttonBelow: '在输入框下方',
      buttonText: '按钮文字',
      buttonRadius: '按钮圆角',
      buttonBgColor: '按钮框体颜色',
      buttonFontSize: '按钮字号',
      buttonTextColor: '按钮文字颜色',
      successHint: '成功提示信息',
      replaceQueryOnSuccess: '替换查询器',
      replaceQueryOnSuccessHelp: '查询成功时会隐藏查询器，在原位置显示成功提示，可点返回继续查询',
      successHintHelp: '查询成功时显示的信息，{seat_number} 会被替换为实际座位号',
      backToQuery: '返回',
      seatNumberOwnLine: '座位号单行显示',
      showGuestName: '显示姓名',
      seatFontSize: '座位字号',
      errorHint: '错误提示信息',
      errorHintHelp: '查询失败时以浮标显示几秒，不占用页面位置',
      hintText: '文案',
      removeComponent: '删除组件',
      saveSuccess: '座位查询页已保存',
      nameDuplicate: '该名称已存在，请修改后再保存',
      saveFailed: '保存失败，请稍后重试',
      previewNeedSave: '请先保存后再浏览 H5 页面',
      resetConfirm: '重置将恢复默认查询页布局（未保存前不会写入数据库），确定继续？',
      resetDone: '已恢复默认布局，请保存后生效',
      switchUnsaved: '当前修改尚未保存，切换页面将丢弃未保存内容，是否继续？',
      switchTitle: '切换页面',
      h5NotFound: '座位查询页不存在或尚未保存',
      phName: '请输入姓名',
      phPhone: '请输入手机号',
      needName: '请输入姓名',
      needPhone: '请输入手机号',
      searchFailed: '查询失败，请稍后重试'
    }
  },
  eventTime: '活动时间',
  timeStartPlaceholder: '开始时间',
  timeEndPlaceholder: '结束时间',
  list: {
    welcomeTitle: 'Welcome!',
    welcomeSubtitle: '欢迎使用半度云智能会务系统',
    welcomePromoTitle: '照片直播 AI 修图功能重磅上新啦',
    welcomePromoDesc: 'AI 赋能极速精修，活动直播帧帧出片。',
    welcomeDocBtn: '查看使用文档',
    colIndex: '序号',
    colActivityInfo: '活动信息',
    colStatus: '活动状态',
    colActions: '操作',
    meetingSessions: '会议场次：{n} 场',
    statTotalActivities: '活动总数',
    statOngoingSub: '进行中 {n} 场',
    statTotalRegistrations: '累计报名人数',
    statTotalCheckins: '累计签到人次',
    statTotalIncome: '累计收益',
    statPageHint: '本页合计',
    unitPerson: '人',
    unitTimes: '次',
    unitWan: '万',
    quickEnterSettings: '进入设置',
    quickSchedule: '会议日程',
    quickRegRecords: '参与记录',
    quickSeating: '座位表',
    quickItinerary: '行程安排',
    quickCheckin: '签到管理',
    quickDecorate: '页面装修',
    quickMicrosite: '活动官网',
    quickAgenda: '会议议程',
    quickJoinReg: '参与报名',
    quickRegRecordsJoined: '报名记录',
    quickSeatingInfo: '座位信息',
    quickHotel: '酒店安排',
    quickOrders: '订单明细',
    tagJoined: '参与的活动',
    tagCreated: '创建的活动',
    filterAllOwnership: '全部的活动',
    filterJoined: '参与的活动',
    filterCreated: '创建的活动',
    inviterLabel: '邀请方：{name}',
    opViewDetail: '查看详情',
    createActivity: '创建活动',
    topForm: '问卷管理',
    topItinerary: '行程预设',
    topPayment: '支付管理',
    topAudit: '名单审核',
    topAssociation: '报名关联',
    allActivities: '所有活动({count})',
    advancedFilter: '高级筛选',
    searchNameOnly: '搜索活动名称',
    countdown: '倒计时',
    share: '分享',
    sort: '排序',
    qrShare: '二维码分享',
    addressUnset: '暂未设置地点',
    statusUnset: '—',
    statusEnded: '已结束',
    statusOngoing: '进行中',
    countdownDays: '{days}天',
    opActivity: '活动',
    opSchedule: '日程',
    opShare: '分享',
    opDecorate: '装修',
    opPayment: '支付',
    opRegistration: '报名',
    opCheckin: '签到',
    opSeating: '座位',
    opDelete: '删除',
    statusAutoTip: '活动状态由系统根据开始/结束时间自动判定：进行中 · 已结束 · 倒计时。',
    statAll: '全部活动',
    statOngoing: '进行中',
    statEnded: '已结束',
    statUnset: '未设置时间',
    filterAllStatus: '全部状态',
    filterOngoing: '进行中',
    filterEnded: '已结束',
    filterUnset: '未设置',
    unitEvent: '场'
  },
  /** 受邀参与的活动工作台 */
  invited: {
    navGroup: '受邀参与的活动',
    navIntro: '活动官网',
    navAgenda: '会议议程',
    navRegistration: '参与报名',
    navOrders: '订单明细',
    introTitle: '活动官网',
    agendaTitle: '活动日程详情',
    regTitle: '参与报名',
    ordersTitle: '活动订单',
    openHome: '新窗口打开',
    phonePreviewTitle: '活动微站首页预览',
    phoneHint: '预览为活动微站首页，可在手机框内滚动浏览',
    noHomePage: '该活动尚未设置微站首页',
    loadHomeFailed: '加载微站首页失败',
    invalidActivity: '无效的活动 ID',
    labelTime: '举办时间',
    labelVenue: '举办地点',
    labelInviter: '主办方 / 邀请方',
    sectionIntro: '活动简介',
    sectionHighlights: '议程亮点',
    contactLabel: '本次活动对接人',
    goRegister: '前往报名'
  },
  /** 酒店库（独立配置，mock；后续对接 API） */
  hotel: {
    listTitle: '酒店列表',
    addHotel: '新增酒店',
    bannerTitle: '这里是酒店库 — 统一管理所有可用酒店',
    bannerHtml: '📋 在此维护平台可用的酒店基础信息，包括酒店名称、地址、设施、套餐模板与门头图片等。<br>🔗 <b>酒店库与活动是分离的</b>：酒店信息在此统一录入和维护，各活动在「活动配置 → 酒店配置」中按需关联本库中的酒店，并可为每场活动单独设置价格与可用房间数。<br>💡 建议先在此处完善酒店信息（含套餐与图片），再前往各活动进行关联配置。',
    empty: '暂无酒店，请点击右上角新增',
    editDetail: '编辑详情',
    backToList: '返回酒店列表',
    detailTitle: '酒店详情',
    saveChanges: '保存修改',
    tabInfo: '🏢 酒店基础信息',
    tabPackages: '🛏️ 酒店套餐',
    tabEnv: '📸 酒店环境',
    tabFacilities: '🏨 酒店设施及周边',
    tabOrders: '📋 订单交易信息',
    ordersComingSoon: '订单功能即将开放',
    facadeTitle: '酒店门头图片',
    uploadImage: '📷 上传图片',
    replace: '替换',
    addFacade: '添加门头图片',
    imageHint: '💡 建议上传酒店外观/门头实拍图，单张图片不超过 5MB，最多 20 张；选图仅本地预览，点击「保存」后上传',
    facadeMaxError: '门头图片最多上传 20 张',
    name: '酒店名称',
    namePlaceholder: '如：广州天河皇冠假日酒店',
    nameRequired: '请填写酒店名称',
    star: '酒店星级',
    starUnit: '星级酒店',
    starUnset: '不设置',
    address: '酒店地址',
    addressPlaceholder: '如：广州市天河区天河路689号',
    addressRequired: '请填写酒店地址',
    phone: '酒店电话',
    phonePlaceholder: '请输入酒店电话',
    phoneRequired: '请填写酒店电话',
    icon: '酒店图标',
    maxRooms: '房间数上限',
    maxRoomsPlaceholder: '0',
    maxRoomsRequired: '请填写房间数上限',
    roomTags: '房间标签',
    roomTagsPlaceholder: '如：双人标准间 ¥580/晚,大床房 ¥680/晚（用逗号分隔）',
    contact: '酒店经理',
    contactPhone: '酒店经理电话',
    tags: '酒店标签',
    tagsPlaceholder: '用逗号分隔多个标签',
    description: '酒店描述',
    descriptionPlaceholder: '描述酒店特色、设施、周边环境等',
    confirmCreate: '确认新增',
    createSuccess: '酒店已创建',
    createFailed: '创建酒店失败',
    saveSuccess: '已保存',
    saveFailed: '保存失败',
    loadFailed: '加载酒店列表失败',
    loadDetailFailed: '加载酒店详情失败',
    deleteConfirm: '确定删除酒店「{name}」吗？',
    deleteSuccess: '已删除',
    deleteFailed: '删除失败',
    uploadSuccess: '上传成功',
    uploadFailed: '上传失败',
    imageSizeError: '图片不能超过 5MB',
    imageTypeError: '仅支持 JPG、PNG、WebP 格式',
    pkgList: '房间套餐列表',
    addPkg: '新增套餐',
    editPkg: '编辑套餐',
    pkgEmpty: '暂无套餐，请先新增',
    perNight: '晚',
    roomCount: '房间总数',
    roomUnit: '间',
    booked: '已预订',
    remain: '剩余',
    breakfast: '早餐',
    breakfastYes: '含早餐',
    breakfastNo: '不含早餐',
    breakfastOptional: '可选早餐',
    pkgImages: '套餐图片',
    addImage: '添加图片',
    pkgImageHint: '💡 建议上传房间实拍图，单张不超过 5MB；选图仅本地预览，确认保存套餐时上传',
    pkgName: '套餐名称',
    pkgNameRequired: '请填写套餐名称',
    beds: '床型',
    area: '面积',
    price: '价格（元/晚）',
    pkgDesc: '套餐描述',
    pkgSaveSuccess: '套餐已保存',
    pkgSaveFailed: '套餐保存失败',
    pkgDeleteConfirm: '确定删除该套餐吗？',
    pkgDeleteSuccess: '套餐已删除',
    pkgDeleteFailed: '删除套餐失败',
    envTip: '环境图用于展示酒店大堂、餐厅、会议室等公共空间；选图仅本地预览，点击「保存」后上传',
    envTitle: '酒店图片',
    clickUpload: '点击上传',
    facilitiesTitle: '酒店设施',
    facilityPlaceholder: '输入新设施名称',
    add: '添加',
    surroundingsTitle: '周边环境',
    surroundingsPlaceholder: '可填写周边景点、交通、餐饮等信息（支持纯文本或简单 HTML）',
    surroundingsHint: '保存时将写入 surroundings 字段；支持纯文本或 HTML',
  }
}
